module.exports = __webpack_public_path__ + "img/08ed7f7.jpg";